import { OlxThemeProvider } from '@olxeu-jobs/ui';
import { Provider as StyletronProvider } from 'styletron-react';
import { forwardRef } from 'react';
import { engine } from './styletron-engine';

type ThemeProviderProps = React.PropsWithChildren<
  Pick<React.ComponentPropsWithoutRef<typeof OlxThemeProvider>, 'platform'>
>;

const OVERRIDES: React.ComponentPropsWithoutRef<typeof OlxThemeProvider>['overrides'] = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  AppContainer: { component: forwardRef(({ children }, ref) => children) },
};

export const ThemeProvider = ({ children, ...props }: ThemeProviderProps) => (
  <StyletronProvider value={engine}>
    <OlxThemeProvider {...props} overrides={OVERRIDES}>
      {children}
    </OlxThemeProvider>
  </StyletronProvider>
);
